"use client";

import type { NewsArticle } from "./stores/useNewsStore";

export function formatPublishedAt(unix: number): { date: string; time: string } {
  if (unix <= 0) return { date: "—", time: "—" };
  const d = new Date(unix * 1000);
  return {
    date: d.toLocaleDateString("en-US", { month: "short", day: "numeric" }),
    time: d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
  };
}

export function listHeadline(article: NewsArticle): string {
  return article.shortHeadline.trim() || article.headline;
}

export type NewsFilterType = "all" | "breaking" | "market_moving";

export function filterNewsArticles(
  articles: NewsArticle[],
  filterType: NewsFilterType,
  searchQuery: string
): NewsArticle[] {
  let list = [...articles];
  const q = searchQuery.trim().toLowerCase();

  if (filterType === "breaking") list = list.filter((a) => a.isBreaking);
  if (filterType === "market_moving") list = list.filter((a) => a.isMarketMoving);

  if (q) {
    list = list.filter(
      (a) =>
        a.headline.toLowerCase().includes(q) ||
        a.shortHeadline.toLowerCase().includes(q) ||
        a.summary.toLowerCase().includes(q) ||
        a.category.toLowerCase().includes(q)
    );
  }

  return list;
}

export function ImportanceMark({ importance, isBreaking }: { importance: number; isBreaking: boolean }) {
  if (isBreaking) {
    return (
      <span className="text-[10px] font-semibold uppercase text-destructive" title="Breaking">
        BREAK
      </span>
    );
  }
  if (importance >= 4) {
    return (
      <span className="text-xs font-bold text-amber-500 dark:text-amber-400" title={`Importance ${importance}`}>
        !
      </span>
    );
  }
  return null;
}
